export function getDefaultImage(imageName) {
  const defaultImagePath = '/img/default/';
  return defaultImagePath + imageName + '/default.jpg';
}